import { useEffect, useState, useRef } from 'react';
import { Button } from 'antd';
import { ExportOutlined, LoadingOutlined } from '@ant-design/icons';
import { CSVLink } from 'react-csv';

import { requestWithAuth } from '../../services/api';

const ExportCsv = (props) => {
  const { downloadFileName = 'Csv_Table', url } = props;
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [csvData, setCsvData] = useState([]);

  const buttonRef = useRef(null);

  const totalPage = Math.ceil(props.totalCount / 100);

  useEffect(() => {
    if (csvData && csvData.length && buttonRef) {
      buttonRef.current.link.click();
      setCsvData([]);
    }
  }, [csvData]);

  const getReports = async (count, acc = []) => {
    setIsExportLoading(true);
    if (count > totalPage) {
      setCsvData(acc);
      setIsExportLoading(false);
      return;
    }
    const params = { ...props.filterParams };
    params.page_size = 100;
    params.page = count;
    if (props.searchQuery) {
      params.q = props.searchQuery;
    }
    try {
      const response = await requestWithAuth(url, 'GET', params, null);
      if (response && response.results) {
        await getReports(count + 1, [...acc, ...response.results]);
      } else {
        setCsvData(acc);
        setIsExportLoading(false);
      }
    } catch (e) {
      console.log('Export-CSV :', e);
      setIsExportLoading(false);
    }
  };

  return (
    <>
      {csvData && csvData.length > 0 ? (
        <CSVLink
          filename={`${downloadFileName}.csv`}
          className="export-csv-reports"
          data={csvData}
          ref={buttonRef}
        >
          <Button
            icon={isExportLoading ? <LoadingOutlined /> : <ExportOutlined />}
            type="primary"
            disabled={isExportLoading}
          >
            Export CSV
          </Button>
        </CSVLink>
      ) : (
        <Button
          icon={isExportLoading ? <LoadingOutlined /> : <ExportOutlined />}
          type="primary"
          disabled={isExportLoading}
          onClick={() => {
            getReports(1);
          }}
        >
          Export CSV
        </Button>
      )}
    </>
  );
};

export default ExportCsv;
